module.exports = __webpack_public_path__ + "img/devday-3.33447001.jpg";